import { useBatchedSimpleUser } from "@/-dataloaders/simple-users"

interface Props {
  userId: number
}

export function PersonNameWithUserNameFallback({ userId }: Props) {
  const { data: user } = useBatchedSimpleUser(userId)
  return user?.userName ?? ""
}
